import { parseActionSet } from './parseMessageCard';
import CustomChoiceSetInput from '../controls/CustomChoiceSetInput';
import CustomDateInput from '../controls/CustomDateInput';
import CustomTextInput from '../controls/CustomTextInput';
import CustomOpenUrlAction from '../cardActions/CustomOpenUrlAction';
import CustomShowCardAction from '../cardActions/CustomShowCardAction';
import ActionProvider from '../store/schema/ActionProvider';
import * as Adaptive from 'adaptivecards';

export default function parseDefaultLegacyMessageCardAction(
    jsonAction: any,
    actionProviders: ActionProvider[]
): Adaptive.Action {
    switch (jsonAction['@type']) {
        case 'OpenUri':
        case 'ViewAction':
            return parseOpenUrlAction(jsonAction);
        case 'ActionCard':
            return parseShowCardAction(jsonAction, actionProviders);
    }

    return null;
}

function parseOpenUrlAction(json: any): CustomOpenUrlAction {
    const action = new CustomOpenUrlAction();
    action.title = json.name;

    if (json.target) {
        action.url = json.target;
    } else if (json.targets && json.targets instanceof Array) {
        for (let i = 0; i < json.targets.length; i++) {
            if (json.targets[i].os === 'default') {
                action.url = json.targets[i].uri;
                break;
            }
        }
    }

    return action;
}

function parseShowCardAction(json: any, actionProviders: ActionProvider[]): CustomShowCardAction {
    const showCardAction = new CustomShowCardAction();
    showCardAction.title = json.name;

    const inputArray = json.inputs as Array<any>;
    if (inputArray) {
        for (let i = 0; i < inputArray.length; i++) {
            const jsonInput = inputArray[i];
            let input: Adaptive.Input = null;

            const inputType = jsonInput['@type'] ? jsonInput['@type'].toLowerCase() : '';
            switch (inputType) {
                case 'textinput':
                    input = parseTextInput(jsonInput);
                    break;
                case 'dateinput':
                    input = parseDateInput(jsonInput);
                    break;
                case 'multichoiceinput':
                    input = parseChoiceSetInput(jsonInput);
                    break;
            }

            if (input) {
                showCardAction.card.addItem(input);
            }
        }
    }

    const actionArray = json.actions;

    if (actionArray) {
        showCardAction.card.addItem(parseActionSet(actionArray, actionProviders));
    }

    return showCardAction;
}

function parseTextInput(json: any): Adaptive.Input {
    const input = new CustomTextInput();
    parseInput(input, json);
    input.placeholder = json.title;
    input.isMultiline = json.isMultiline;

    return input;
}

function parseDateInput(json: any): Adaptive.Input {
    const input = new CustomDateInput();
    parseInput(input, json);
    input.placeholder = json.title;
    return input;
}

function parseChoiceSetInput(json: any): Adaptive.Input {
    const input = new CustomChoiceSetInput();
    parseInput(input, json);
    input.placeholder = json.title;
    input.spacing = Adaptive.Spacing.Medium;

    const choiceArray = json.choices as Array<any>;

    if (choiceArray) {
        for (let i = 0; i < choiceArray.length; i++) {
            const choice = new Adaptive.Choice();
            choice.title = choiceArray[i].display;
            choice.value = choiceArray[i].value;
            input.choices.push(choice);
        }
    }

    input.isMultiSelect = json.isMultiSelect;
    input.isCompact = !(json.style === 'expanded');
    input.initialize();

    return input;
}

function parseInput(input: Adaptive.Input, json: any) {
    input.id = json.id;
    input.defaultValue = json.value;
}
